import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { updateNotification, selectNotifications } from '../../store/settingsSlice';
import type { NotificationSettings } from '../../store/settingsSlice';

const notificationOptions = [
    { key: 'priceAlerts' as keyof NotificationSettings, label: 'Price Alerts', desc: 'Get notified when prices hit your targets' },
    { key: 'newsUpdates' as keyof NotificationSettings, label: 'News Updates', desc: 'Market news and company announcements' },
    { key: 'tradingSignals' as keyof NotificationSettings, label: 'Trading Signals', desc: 'AI-powered trading opportunities' },
    { key: 'marketOpen' as keyof NotificationSettings, label: 'Market Open/Close', desc: 'Daily market hours notifications' }
];

const NotificationsSection = () => {
    const dispatch = useAppDispatch();
    const notifications = useAppSelector(selectNotifications);

    return (
        <div style={{
            backgroundColor: 'var(--color-surface)',
            border: '1px solid var(--color-border-light)',
            borderRadius: 'var(--radius-lg)',
            padding: 'var(--spacing-lg)',
            boxShadow: 'var(--shadow-sm)'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--spacing-md)',
                marginBottom: 'var(--spacing-lg)',
                paddingBottom: 'var(--spacing-lg)',
                borderBottom: '1px solid var(--color-border-light)'
            }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--color-primary-600)">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
                <h2 style={{
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    color: 'var(--color-text-primary)',
                    margin: 0
                }}>
                    Notifications
                </h2>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)' }}>
                {notificationOptions.map(item => (
                    <label key={item.key} style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: 'var(--spacing-sm)',
                        borderRadius: 'var(--radius-md)',
                        cursor: 'pointer',
                        transition: 'background-color 200ms ease-in-out'
                    }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--color-gray-50)'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                        <div style={{ flex: 1 }}>
                            <div style={{
                                fontSize: '0.875rem',
                                fontWeight: '500',
                                color: 'var(--color-text-primary)',
                                marginBottom: '2px'
                            }}>
                                {item.label}
                            </div>
                            <div style={{
                                fontSize: '0.75rem',
                                color: 'var(--color-text-secondary)'
                            }}>
                                {item.desc}
                            </div>
                        </div>
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                            <input
                                type="checkbox"
                                checked={notifications[item.key]}
                                onChange={(e) => dispatch(updateNotification({
                                    key: item.key,
                                    value: e.target.checked
                                }))}
                                style={{ display: 'none' }}
                                id={`notification-${item.key}`}
                            />
                            <div style={{
                                width: '44px',
                                height: '24px',
                                backgroundColor: notifications[item.key] ? 'var(--color-primary-600)' : 'var(--color-gray-300)',
                                borderRadius: '12px',
                                position: 'relative',
                                transition: 'background-color 200ms ease-in-out',
                                cursor: 'pointer'
                            }}>
                                <div style={{
                                    width: '20px',
                                    height: '20px',
                                    backgroundColor: 'white',
                                    borderRadius: '50%',
                                    position: 'absolute',
                                    top: '2px',
                                    left: notifications[item.key] ? '22px' : '2px',
                                    transition: 'left 200ms ease-in-out',
                                    boxShadow: 'var(--shadow-sm)'
                                }} />
                            </div>
                        </div>
                    </label>
                ))}
            </div>
        </div>
    );
};

export default NotificationsSection;
